import ListItem from './ListItem.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(config, 'listItem', ListItem);
  },
};
